import { BASE_API_URL } from '@/constant/api'
import { AppResp } from '@/types/api'
import {
  CharacterConversationStyleRes,
  CharacterFeedReq,
  CharacterGetRes,
  HomeFilterContentType,
  CharacterPublicListResponse,
  CreatorCharacterListReq,
  HomeCharacterForYouReq,
  HomeCharacterListReq,
  ProfileCharacterListRes,
  ScreenList,
  SelfCharacterListReq,
  HomeStoryReq,
  HomeStoryList,
  StoryDetail,
  StoryRelation,
  CharacterGetResWithStory,
  CharacterPublicListResponseWithStory,
  CreatorCharacterListV2Req,
  CreatorCharacterListV2Res,
} from '@/types/character'
import { axiosAuth, axiosPublic } from '@/utils/axios'
import { ISearchResultData } from 'Types/serach'
import { User } from '@/types/user'
import { TagData, TagID } from '@/types/tag'
import { uuid } from '@/utils/func'
import { createDisabledCharacterVoiceParam } from '@/utils/voice'
// 获取标签列表
export const getCharacterTags = async (nsfw: boolean = false) => {
  const result = await axiosPublic.post<
    AppResp<{
      total: number
      tags: TagData[]
    }>
  >(`${BASE_API_URL}/character/tags`, { nsfw })
  if (!result.data.data) {
    throw new Error('No character tags data')
  }
  return result.data.data.tags
}

export const getCharacterPublicByUser = async (
  character_id: string,
  nsfw: boolean,
  language_code: string
) => {
  const res = await axiosAuth.post<AppResp<CharacterGetRes>>(
    `${BASE_API_URL}/character/get/public`,
    { character_id, nsfw, language_code }
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}

export const getCharacterPublic = async (
  character_id: string,
  nsfw: boolean,
  language_code: string
) => {
  const res = await axiosPublic.post<AppResp<CharacterGetRes>>(
    `${BASE_API_URL}/character/get/public`,
    { character_id, nsfw, language_code }
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}

export const storyPublicKey = `${BASE_API_URL}/story/detail`
export const getStoryPublic = async (
  story_id: string,
  language_code: string
) => {
  const res = await axiosPublic.post<AppResp<StoryDetail>>(storyPublicKey, {
    story_id,
    language_code,
  })
  if (!res.data.data) {
    throw new Error('No character data')
  }
  const { story } = res.data.data
  res.data.data.character = {
    ...story,
    is_translated: story.is_translated,
    greeting: story.opening_remarks,
    introduction: story.summary,
    nickname: story.title,
    character_id: story.story_id,
    voice_param: createDisabledCharacterVoiceParam(),
    voice_supported: false,
  }
  return res.data.data
}

export const getCharacterListPublic = async (req: HomeCharacterListReq) => {
  const res = await axiosPublic.post<
    AppResp<CharacterPublicListResponseWithStory>
  >(`${BASE_API_URL}/character/get/public_list`, req)
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data.list || []
}

export const getCharacterListPublicKey =
  (req: Omit<HomeCharacterListReq, 'page'>) =>
  (page: number, previousPageData: CharacterGetRes[]) => {
    if (previousPageData && previousPageData.length === 0) return null
    return { endpoint: '/character/get/public_list', req: { ...req, page } }
  }

export const getCharacterForYouListPublic = async (
  req: HomeCharacterForYouReq
) => {
  const res = await axiosPublic.post<
    AppResp<CharacterPublicListResponseWithStory>
  >(`${BASE_API_URL}/recommend/recommend_feed/list`, {
    ...req,
    tag_ids: req.tag_ids || [],
  })
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data.list || []
}

export const getCharacterForYouListPublicKey =
  (req: Omit<HomeCharacterForYouReq, 'page'>) =>
  (page: number, previousPageData: CharacterGetResWithStory[]) => {
    return { endpoint: '/recommend/recommend_feed/list', req: { ...req, page } }
  }

// TODO: 接口可能还会改动
export const getSelfCharacterList = async (req: SelfCharacterListReq) => {
  const res = await axiosAuth.post<AppResp<ProfileCharacterListRes>>(
    `${BASE_API_URL}/character/list/self`,
    req
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}

// 未成年保护申诉
export const getCharacterAppeal = async (character_id: string) => {
  const res = await axiosAuth.post<AppResp<{ review_id: string }>>(
    `${BASE_API_URL}/character/appeal`,
    { character_id }
  )
  if (!res.data.data) {
    throw new Error('No appeal data')
  }
  return res.data.data
}

export const getStoryAppeal = async (story_id: string) => {
  const res = await axiosAuth.post<AppResp<{ review_id: string }>>(
    `${BASE_API_URL}/story/appeal`,
    { story_id }
  )
  if (!res.data.data) {
    throw new Error('No appeal data')
  }
  return res.data.data
}

//个人角色列表数据
export const getSelfCharacterListKey =
  (req: Omit<SelfCharacterListReq, 'page'>) =>
  (page: number, previousPageData: ProfileCharacterListRes) => {
    if (
      previousPageData &&
      (!previousPageData.characters ||
        previousPageData.characters.length < req.size)
    )
      return null
    return { endpoint: 'character/list/self', req: { ...req, page } }
  }
export const getCreatorCharacterList = async (req: CreatorCharacterListReq) => {
  const res = await axiosPublic.post<AppResp<ProfileCharacterListRes>>(
    `${BASE_API_URL}/character/list/creator`,
    req
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}

export const getCreatorCharacterListKey =
  (req: Omit<CreatorCharacterListReq, 'page'>) =>
  (page: number, previousPageData: ProfileCharacterListRes) => {
    if (
      previousPageData &&
      (!previousPageData.characters ||
        previousPageData.characters?.length < req.size)
    )
      return null
    return { endpoint: 'character/list/creator', req: { ...req, page } }
  }

export const getCreatorCharacterListV2 = async (
  req: CreatorCharacterListV2Req
) => {
  const res = await axiosPublic.post<AppResp<CreatorCharacterListV2Res>>(
    `${BASE_API_URL}/character/list/creator/v2`,
    req
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}

export const getCreatorCharacterListV2Key =
  (req: Omit<CreatorCharacterListV2Req, 'page'>) =>
  (page: number, previousPageData: CreatorCharacterListV2Res) => {
    if (
      previousPageData &&
      (!previousPageData.list || previousPageData.list.length < req.size)
    )
      return null
    return { endpoint: 'character/list/creator/v2', req: { ...req, page } }
  }

// 获取聊天风格
export const getConversationStyle = async (language_code: string) => {
  const res = await axiosPublic.post<AppResp<CharacterConversationStyleRes[]>>(
    `${BASE_API_URL}/character/get_conversation_style`,
    { language_code }
  )
  if (!res.data.data) {
    throw new Error('No conversation style data')
  }
  return res.data.data
}

// 获取角色大屏
export const getCharacterFeedListKey = `${BASE_API_URL}/character_feed/list`
export const getCharacterFeedList = async (req: CharacterFeedReq) => {
  const res = await axiosPublic.post<AppResp<ScreenList>>(
    getCharacterFeedListKey,
    req
  )
  if (!res.data.data) {
    throw new Error('No character data')
  }
  return res.data.data
}
type CharacterTranslationStatusRes = {
  is_translated: boolean
  status: string
}
export const getCharacterTranslationStatus = async (
  character_id: string,
  language_code: string
) => {
  const res = await axiosAuth.post<AppResp<CharacterTranslationStatusRes>>(
    `${BASE_API_URL}/character/translation_status`,
    { character_id, language_code }
  )
  return res.data.data
}
export const getStoryTranslationStatus = async (
  story_id: string,
  language_code: string
) => {
  const res = await axiosAuth.post<AppResp<CharacterTranslationStatusRes>>(
    `${BASE_API_URL}/story/translation_status`,
    { story_id, language_code }
  )
  return res.data.data
}

// 获取热门标签
export const getPopularTags = async () => {
  const res = await axiosPublic.post<
    AppResp<{ Score: number; Member: string }[]>
  >(`${BASE_API_URL}/search/popular_search_terms`)
  return res.data.data
}

// 搜索建议词
export const getSuggestSearch = async (searchTerm: string) => {
  const res = await axiosPublic.post<AppResp<string[]>>(
    `${BASE_API_URL}/search/character/suggest`,
    { search_term: searchTerm }
  )
  return res.data.data?.map((item) => item?.trim?.() ?? item)
}

// 获取最近的搜索记录
export const getRecentHistory = async () => {
  const res = await axiosAuth.post<AppResp<string[]>>(
    `${BASE_API_URL}/search/recent_history`,
    { size: 10 }
  )
  return res.data.data
}

// 清除最近的搜索记录
export const clearRecentHistory = async () => {
  const res = await axiosAuth.post<AppResp<string>>(
    `${BASE_API_URL}/search/clear_history`
  )
  return res.data.data
}

// 角色搜索
export const getCharacterSearch = async (params: {
  search_term: string
  page: number
  size: number
  tags: TagID[]
  language_code: string
  content_type?: HomeFilterContentType
  nsfw: boolean
  gender?: string
  sorting?: string
  content_rating?: string
}) => {
  const res = await axiosPublic.post<
    AppResp<{
      total: number
      search_session_id: string
      hits: ISearchResultData[]
      // 命中结果的标签聚合（仅第 1 页返回），横滑标签栏数据源；按命中数倒序
      tag_aggs?: { tag_id: string; count: number }[]
    }>
  >(`${BASE_API_URL}/search/character_search`, params)
  return res.data.data
}

// 用户搜索
export const getCreatorSearch = async (
  searchTerm: string,
  page: number,
  enable_blacklist_filter?: boolean
) => {
  const res = await axiosPublic.post<
    AppResp<{
      total: number
      search_session_id: string
      hits: User[]
    }>
  >(`${BASE_API_URL}/search/user_search`, {
    search_term: searchTerm,
    page: page,
    size: 20,
    enable_blacklist_filter: enable_blacklist_filter,
  })
  return res.data.data
}

export const getStoryListKey =
  (req: Omit<HomeStoryReq, 'page'>) =>
  (page: number, previousPageData: HomeStoryList[]) => {
    if (previousPageData && previousPageData.length < req.size) return null
    return {
      endpoint: '/story/list',
      req: { ...req, page },
    }
  }

export const getStoryList = async (
  req: HomeStoryReq,
  language_code: string
) => {
  const res = await axiosPublic.post<AppResp<HomeStoryList>>(
    `${BASE_API_URL}/story/list`,
    { ...req, language_code }
  )

  if (!res.data.data) {
    throw new Error('No story data')
  }
  return res.data.data.storys || []
}

export const getStoryRelation = async (character_id: string) => {
  const res = await axiosPublic.post<AppResp<StoryRelation>>(
    `${BASE_API_URL}/character/story/relation`,
    { character_id }
  )
  return res.data.data
}

export const togglePinCharacter = async (
  item_id: string,
  item_type: 'character' | 'story' | 'game'
) => {
  const res = await axiosAuth.post<AppResp<{ is_pinned: boolean }>>(
    `${BASE_API_URL}/character/toggle_pin`,
    { item_id, item_type }
  )
  return res.data.data
}
